import { __assign } from "tslib";
export var InvalidInputException;

(function (InvalidInputException) {
  InvalidInputException.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(InvalidInputException || (InvalidInputException = {}));

export var Event;

(function (Event) {
  Event.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(Event || (Event = {}));

export var PutEventsRequest;

(function (PutEventsRequest) {
  PutEventsRequest.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(PutEventsRequest || (PutEventsRequest = {}));

export var Item;

(function (Item) {
  Item.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(Item || (Item = {}));

export var PutItemsRequest;

(function (PutItemsRequest) {
  PutItemsRequest.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(PutItemsRequest || (PutItemsRequest = {}));

export var ResourceNotFoundException;

(function (ResourceNotFoundException) {
  ResourceNotFoundException.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));

export var User;

(function (User) {
  User.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(User || (User = {}));

export var PutUsersRequest;

(function (PutUsersRequest) {
  PutUsersRequest.filterSensitiveLog = function (obj) {
    return __assign({}, obj);
  };
})(PutUsersRequest || (PutUsersRequest = {}));